/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchMinimumCartSystemAdminDto } from '../models/BranchMinimumCartSystemAdminDto';
import type { BranchMinimumCartSystemValueType } from '../models/BranchMinimumCartSystemValueType';
import type { Pagination1OfBranchMinimumCartSystemAdminDto } from '../models/Pagination1OfBranchMinimumCartSystemAdminDto';
import type { PostPutBranchMinimumCartSystemRequestAdmin } from '../models/PostPutBranchMinimumCartSystemRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchMinimumCartSystemsService {
    /**
     * **Required Policy:** `ViewBranchMinimumCartSystems`
     * @returns Pagination1OfBranchMinimumCartSystemAdminDto OK
     * @throws ApiError
     */
    public static getBranchMinimumCartSystemsAdmin({
        name,
        isDefault,
        valueType,
        page,
        limit,
    }: {
        name?: string,
        isDefault?: boolean,
        valueType?: BranchMinimumCartSystemValueType,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchMinimumCartSystemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchminimumcartsystems',
            query: {
                'name': name,
                'isDefault': isDefault,
                'valueType': valueType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchMinimumCartSystems`
     * @returns BranchMinimumCartSystemAdminDto OK
     * @throws ApiError
     */
    public static postBranchMinimumCartSystemAdmin({
        requestBody,
    }: {
        requestBody?: PostPutBranchMinimumCartSystemRequestAdmin,
    }): CancelablePromise<BranchMinimumCartSystemAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branchminimumcartsystems',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchMinimumCartSystems`
     * @returns BranchMinimumCartSystemAdminDto OK
     * @throws ApiError
     */
    public static getBranchMinimumCartSystemAdmin({
        branchMinimumCartSystemId,
    }: {
        branchMinimumCartSystemId: number,
    }): CancelablePromise<BranchMinimumCartSystemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchminimumcartsystems/{branchMinimumCartSystemId}',
            path: {
                'branchMinimumCartSystemId': branchMinimumCartSystemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchMinimumCartSystems`
     * @returns BranchMinimumCartSystemAdminDto OK
     * @throws ApiError
     */
    public static putBranchMinimumCartSystemAdmin({
        branchMinimumCartSystemId,
        requestBody,
    }: {
        branchMinimumCartSystemId: number,
        requestBody?: PostPutBranchMinimumCartSystemRequestAdmin,
    }): CancelablePromise<BranchMinimumCartSystemAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branchminimumcartsystems/{branchMinimumCartSystemId}',
            path: {
                'branchMinimumCartSystemId': branchMinimumCartSystemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteBranchMinimumCartSystems`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBranchMinimumCartSystemAdmin({
        branchMinimumCartSystemId,
    }: {
        branchMinimumCartSystemId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/branchminimumcartsystems/{branchMinimumCartSystemId}',
            path: {
                'branchMinimumCartSystemId': branchMinimumCartSystemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
